import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Collection } from '../collection'
import type { TypeParams } from '../types'

/**
 * When organization assignments are added, updated, or deleted,
 * reload the current record to reflect the changes in history log
 */
export const reloadOnOrgAssignmentChange = store.effects.create(
  (_: ec.Collection<TypeParams>['feature'], collection: Collection) =>
    ec.models.CollectionProducer.getEc$(ec.Name.Predefined.SpaceOrgAssignment, {
      waitUntilReady: true,
    }).pipe(
      rxjs.switchMap(orgAssignmentsEc =>
        orgAssignmentsEc.plugins.editingPlugin.feature.actions.submit.success
          .observe()
          .pipe(
            rxjs.map(() =>
              collection.plugins.currentEntityPlugin.feature.actions.getEntity
                .from('(effect) reload record on org assignment change')
                .create({}),
            ),
          ),
      ),
    ),
)
